export const AUTHENTICATION_ERROR_MESSAGE =
  'you must be logged in to query this schema'
export const DAILY_ACCESS_TOKEN = 'DAILY_ACCESS_TOKEN'
